import { render, staticRenderFns } from "./SemiologiaCardiologica.vue?vue&type=template&id=73c5c428"
import script from "./SemiologiaCardiologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaCardiologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports